import { isNumber, reduce } from "lodash";












const ssrInitialState = {
  select: "tc-01",
  buttonStatus: "on",
  switchName: null,
  description: [null, null, null],
  index: 1,
  isSettingOpen: false,
  openPasswordBox: false,
};




export const EMPTY_SSR_STATE = Object.freeze({
  ssr1: Object.freeze({ ...ssrInitialState, specs: [] }),
  ssr2: Object.freeze({
    ...ssrInitialState,
    currentCurrent: 0,
    specs: [],
    buttonStatus: "flt",
  }),
  ssr3: Object.freeze({ ...ssrInitialState, specs: [] }),
  ssr4: Object.freeze({
    ...ssrInitialState,
    specs: [],
    currentCurrent: [10.65],
  }),
  ssr5: Object.freeze({ ...ssrInitialState, specs: [] }),
  ssr6: Object.freeze({ ...ssrInitialState, specs: [] }),
  ssr7: Object.freeze({
    ...ssrInitialState,
    specs: [],
    buttonStatus: "off",
  }),
  ssr8: Object.freeze({ ...ssrInitialState, specs: [] }),
});



export const buildSsrStateFromRest = (prevSsrState = EMPTY_SSR_STATE, data = []) =>
  Object.fromEntries(
    Object.entries(
      reduce(
        data,
        (result, ssr) => {
          // A record with a missing No must not claim a slot: `null + 1` is 1,
          // so it collides with SSR-0 and silently overwrites it.
          if (!isNumber(ssr.No)) {
            return result;
          }
          return {
            ...result,
            [`ssr${ssr.No + 1}`]: {
              ...prevSsrState[`ssr${ssr.No + 1}`],
              ...ssr,
            },
          };
        },
        {}
      )
    ).sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
  );



export const applySsrSocketSpecs = (
  prevSsrState = EMPTY_SSR_STATE,
  data,
  heaterThermocoupleMap = []
) => {
  // Without a valid No there is no slot to address: the key would collide
  // with SSR-0 and the malformed record would win.
  if (!isNumber(data?.No)) {
    return prevSsrState;
  }
  const key = `ssr${data.No + 1}`;
  return {
    ...prevSsrState,
    [key]: {
      ...prevSsrState[key],
      ...data,
      select: `tc-${heaterThermocoupleMap[data.No]}`,
      buttonStatus:
        data?.fault === true || data?.Load_exceeded === true
          ? "flt"
          : data?.active === true
          ? "on"
          : "off",
      switchName: `${data.name} ${data.size}`,
    },
  };
};



export const applySsrSocketThermocouple = (
  prevSsrState = EMPTY_SSR_STATE,
  heaterThermocoupleMap = []
) => {
  const next = { ...prevSsrState };
  heaterThermocoupleMap.forEach((el, index) => {
    const key = `ssr${index + 1}`;
    next[key] = { ...next[key], select: `tc-${el}` };
  });
  return next;
};



export const setSsrField = (prevSsrState = EMPTY_SSR_STATE, id, field, value) => ({
  ...prevSsrState,
  [id]: { ...prevSsrState[id], [field]: value },
});






export const mergeSsrStateIntoFlat = (flatSwitch = {}, readSsr) =>
  Object.fromEntries(
    Object.entries(flatSwitch).map(([location, machines]) => [
      location,
      Object.fromEntries(
        Object.entries(machines || {}).map(([key, machineData]) => [
          key,
          machineData?.deviceMac
            ? { ...machineData, ssrState: readSsr(machineData.deviceMac) }
            : machineData,
        ])
      ),
    ])
  );
